
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.178","height":"14.184"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19281","data-name":"Path 19281","d":"M4.439 14.184a4.432 4.432 0 01-1.2-8.7 4.354 4.354 0 012.294-.028L10.2.785A2.659 2.659 0 0112.1 0a2.092 2.092 0 012.09 2.09 2.664 2.664 0 01-.785 1.9l-.4.4a1.19 1.19 0 01-.836.346h-.937v.591A1.182 1.182 0 0110.051 6.5H9.46v.937a1.174 1.174 0 01-.346.836l-.384.384a4.334 4.334 0 01-.03 2.294 4.45 4.45 0 01-3.8 3.208 4.524 4.524 0 01-.463.024zm0-7.683a3.25 3.25 0 103.126 4.131 3.191 3.191 0 00-.059-1.95.591.591 0 01.141-.612l.631-.632V6.5A1.182 1.182 0 019.46 5.319h.591v-.591a1.182 1.182 0 011.182-1.182h.937l.4-.4a1.489 1.489 0 00.439-1.059.908.908 0 00-.907-.908 1.489 1.489 0 00-1.06.439L6.115 6.544a.591.591 0 01-.612.14A3.228 3.228 0 004.436 6.5zm-1.48 4.137a.591.591 0 10.591-.591.591.591 0 00-.591.591z","transform":"translate(-.009)","fill":"#5f6368"}})])
          )
        }
      }
    